/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DeleteEvidenceInput = {
    folderId: string;
    evidenceIds: Array<string>;
    clientMutationId?: string | null | undefined;
};
export type deleteEvidenceMutationVariables = {
    input: DeleteEvidenceInput;
};
export type deleteEvidenceMutationResponse = {
    readonly deleteEvidence: {
        readonly folder: {
            readonly evidenceCount: number;
            readonly " $fragmentRefs": FragmentRefs<"evidenceList_folderEvidenceFull">;
        };
        readonly allFilesFolder: {
            readonly evidenceCount: number;
        };
        readonly evidenceNodes: ReadonlyArray<{
            readonly node: {
                readonly id: string;
            };
        }>;
    } | null;
};
export type deleteEvidenceMutation = {
    readonly response: deleteEvidenceMutationResponse;
    readonly variables: deleteEvidenceMutationVariables;
};



/*
mutation deleteEvidenceMutation(
  $input: DeleteEvidenceInput!
) {
  deleteEvidence(input: $input) {
    folder {
      __typename
      evidenceCount
      ...evidenceList_folderEvidenceFull
      id
    }
    allFilesFolder {
      evidenceCount
      id
    }
    evidenceNodes {
      node {
        __typename
        id
      }
    }
  }
}

fragment evidenceList_folderEvidenceFull on Folder {
  __isFolder: __typename
  evidences {
    edges {
      node {
        __typename
        id
        fileName: name
        storedOn: created
        eventDate
        size
        folderCount
        tagCount
        commentCount
        tags: tagsWithIds {
          id
          text
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "evidenceCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteEvidenceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteEvidencePayload",
        "kind": "LinkedField",
        "name": "deleteEvidence",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "evidenceList_folderEvidenceFull"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AllFilesFolder",
            "kind": "LinkedField",
            "name": "allFilesFolder",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EvidenceNode",
            "kind": "LinkedField",
            "name": "evidenceNodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteEvidenceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteEvidencePayload",
        "kind": "LinkedField",
        "name": "deleteEvidence",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folder",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isFolder"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EvidenceConnection",
                "kind": "LinkedField",
                "name": "evidences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EvidenceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": "fileName",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": "storedOn",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "created",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "size",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "folderCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tagCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentCount",
                            "storageKey": null
                          },
                          {
                            "alias": "tags",
                            "args": null,
                            "concreteType": "TagWithId",
                            "kind": "LinkedField",
                            "name": "tagsWithIds",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AllFilesFolder",
            "kind": "LinkedField",
            "name": "allFilesFolder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EvidenceNode",
            "kind": "LinkedField",
            "name": "evidenceNodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteRecord",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "id"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec01f5320d5d009b7d40d80a445923d9",
    "id": null,
    "metadata": {},
    "name": "deleteEvidenceMutation",
    "operationKind": "mutation",
    "text": "mutation deleteEvidenceMutation(\n  $input: DeleteEvidenceInput!\n) {\n  deleteEvidence(input: $input) {\n    folder {\n      __typename\n      evidenceCount\n      ...evidenceList_folderEvidenceFull\n      id\n    }\n    allFilesFolder {\n      evidenceCount\n      id\n    }\n    evidenceNodes {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment evidenceList_folderEvidenceFull on Folder {\n  __isFolder: __typename\n  evidences {\n    edges {\n      node {\n        __typename\n        id\n        fileName: name\n        storedOn: created\n        eventDate\n        size\n        folderCount\n        tagCount\n        commentCount\n        tags: tagsWithIds {\n          id\n          text\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f8cc92fb2738ea5e16b97f711631a73b';
export default node;
